import { useState } from 'react';
import { useRouter } from 'next/router';
import { scrollToElement } from 'lib/common';
import {
  ReaderBlockDiscussionCommentContent,
  ReaderBlockDiscussionCommentForm
} from '.';

import type { CommonBlockPropsReader } from 'components/reader/blocks';
import type {
  DiscussionComment,
  DiscussionSubmitObj
} from './ReaderBlockDiscussion';

interface Props
  extends Pick<CommonBlockPropsReader<'discussion'>, 'font' | 'fontSize'> {
  comment: DiscussionComment;
  onDelete: (
    commentId: number,
    parentCommentId?: number,
    deletionReason?: string
  ) => Promise<void>;
  onSaveChanges: (saveObj: DiscussionSubmitObj) => Promise<void>;
  parentCommentId?: number;
}

const ReaderBlockDiscussionComment = ({
  comment,
  font,
  fontSize,
  onDelete,
  onSaveChanges,
  parentCommentId
}: Props) => {
  const { query } = useRouter();

  const scrollToComment =
    parseInt(query.commentId as string, 10) === comment.id;

  const [haveMoved, setHaveMoved] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleEdit = () => setIsEditing(true);

  const handleEditCancel = () => setIsEditing(false);

  const moveToComment = (element: HTMLDivElement) => {
    if (haveMoved) return;
    if (element) {
      scrollToElement({ element });
      setHaveMoved(true);
    }
  };

  return (
    <div className="comment">
      {isEditing ? (
        <div className="form">
          <ReaderBlockDiscussionCommentForm
            comment={comment}
            isChildForm={Boolean(parentCommentId)}
            isEditMode={true}
            fontSize={fontSize}
            onCancel={handleEditCancel}
            onSubmit={onSaveChanges}
            parentCommentId={parentCommentId}
          />
        </div>
      ) : (
        <div
          className="content"
          {...(scrollToComment
            ? { ref: (element) => moveToComment(element) }
            : {})}
        >
          <ReaderBlockDiscussionCommentContent
            comment={comment}
            font={font}
            fontSize={fontSize}
            onDelete={onDelete}
            onEdit={handleEdit}
          />
        </div>
      )}
    </div>
  );
};

export default ReaderBlockDiscussionComment;
